module.exports = __webpack_public_path__ + "static/media/EmiratesIDCard.119cb973.svg";